import { render } from "./ScamInfoView.vue?vue&type=template&id=34d8da2a&scoped=true"
import script from "./ScamInfoView.vue?vue&type=script&lang=js"
export * from "./ScamInfoView.vue?vue&type=script&lang=js"

import "./ScamInfoView.vue?vue&type=style&index=0&id=34d8da2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d8da2a"]])

export default __exports__